import actions from './constants';

export const fetchDatasetStatus = (code) => ({
  code,
  type: actions.FETCH_DATASET_STATUS,
});

export const fetchDatasetStatusSuccess = (code, result) => ({
  code,
  result,
  type: actions.FETCH_DATASET_STATUS_SUCCESS,
});

export const fetchDatasetStatusError = (code, error) => ({
  code,
  error,
  type: actions.FETCH_DATASET_STATUS_ERROR,
});
